export { default } from './PoweredBy';
